<template>
  <div class="mx-2 mb-2 mt-1">
    <span class="display-1 text-capitalize">{{title}}</span>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: () => null
      }
    },

    created() {
      document.title = this.title;
    }
  }
</script>